export const breakpoints = {
  values: {
    xs: 414,
    sm: 768,
    md: 1440,
    lg: 1536,
    xl: 1920,
  },
};
